/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-constructed-context-values */
import {
  createContext, useContext, useEffect, useState
} from 'react';
import io from 'socket.io-client';
import dayjs from 'dayjs';
import { getSessionUser } from '../utils/authentication';
import notificationWithIcon from '../utils/notification';

const SocketContext = createContext();
export const useSocketContext = () => useContext(SocketContext);

export function SocketContextProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [arrivedUser, setArrivedUser] = useState(null);
  const authUser = getSessionUser();

  useEffect(() => {
    if (authUser) {
      const socketIo = io(process.env.REACT_APP_SOCKET_BASE_URL, {
        query: { userId: authUser._id }
      });
      setSocket(socketIo);

      socketIo.on('attendance_created', (notification) => {
        notificationWithIcon('info', `${notification?.payload?.user?.name}\n${notification?.payload?.user?.quartier}`, `Heure d'arriver ${dayjs(notification?.payload?.createdAt).format('HH:mm')}`, 60);
        setArrivedUser(notification?.payload?.userDetails);
      });

      return () => {
        socketIo.off('attendance_created');
        socketIo.close();
      };
    }

    if (socket) {
      socket.close();
      setSocket(null);
    }
  }, []);

  return (
    <SocketContext.Provider value={{ socket, arrivedUser }}>
      {children}
    </SocketContext.Provider>
  );
}
